// the css is injected automatically
require('!style-loader!css-loader!postcss-loader!stylus-loader!./consentemail.styl');

// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");
var radiobutton = require("../radiobutton/radiobutton");
var getData = require('../../scripts/getdata')(MBGF.mbfa_apibase);
var validation = require('validation')(getData).consentemail;
var parsing = require('parsing').consentemail;
var moduleHelper = require('../../scripts/module-helper');

var isAdmin = ( MBGF && MBGF.isAdmin == '1' );

function parse(text, next) {
    strip(require('raw!./consentemail.html'), function(outputHtml) {
        var match = parsing.parse(text);

        var options;

        if (match) {

            var container = document.createElement("div");
            container.innerHTML = outputHtml;
            var domObj = container.firstChild;

            // add a "required" class to the parent node
            // domObj.setAttribute("class", domObj.getAttribute("class") + " required");
            // domObj.setAttribute("data-required", "true");

            //if( !isAdmin ) {
            //outputHtml = container.innerHTML.replace(" = (", "* = (");
            //}
            //else {
                outputHtml = container.innerHTML;
            //}

            text = text.replace(match[0], outputHtml);
            next(text);
        }
        else {
            next(text);
        }
    });

};

function validate(context, err, formRoot, forceRequired) {

    //var subscribeContext = formRoot ? formRoot.querySelector('[data-module="subscribe"]') : null;

    var isSubscribe = false;
    //if (subscribeContext &&  subscribeContext.active()) {
    //isSubscribe = true;
    //}

    // validate data-dependencies
    var value = get(context);

    var validationResult = !err ? validation.validate(value, true) : err;

    // If nothing is chosen, then its ok and considered valid.
    if (!value && !forceRequired) {
        validationResult.valid = true;
    } else if (value && forceRequired) {
        validationResult.valid = true;
    }

    // Check if the consent part is forced, meaning that one value has to be choosen
    // but only if the user has given email
    if (checkForced(context, value)) {
        validationResult.valid = false;
    }

    var messagelabel = context.querySelector("#txt_consentemail-error");
    messagelabel.innerHTML = "";

    // if (forceRequired && !value) {
        // validationResult.valid = true;
        // } else if (forceRequired && value) {
        // validationResult.valid = false;
        // } else if (isSubscribe && value === 'denyemail') {
        //validationResult.valid = false;
    // }

    if (!validationResult.valid) {
        //input.setAttribute("class", currentClasses + " error");
        var message = document.createTextNode(context.getAttribute("data-msg-required"));
        messagelabel.appendChild(message);
        messagelabel.setAttribute("class", " error");
    }
    else {
        //input.setAttribute("class", currentClasses + " valid");
        var message = document.createTextNode(context.getAttribute("data-msg-valid"));
        messagelabel.appendChild(message);
        messagelabel.setAttribute("class", " valid");
    }

    return validationResult.valid;
}

function init(formRoot, meta, next) {

    var context = formRoot.querySelector('[data-module="consentemail"]');

    if( context ) {

        // We dont want the two checkboxes to be selected, just one.
        // This is similar to a radio button, but with the difference
        // that you should be able to uncheck all
        var checkboxes = context.querySelectorAll('input');

        checkboxes.forEach(function(box) {
            box.addEventListener('change', function() {
                if (this.checked) {
                    checkboxes.forEach(function(box2) {
                        if (box2 !== box) {
                            box2.checked = false;
                        }
                    });
                }

                // Check if the consent part is forced, meaning that one value has to be choosen
                // but only if the user has given email
                var force = checkForced(context, false);

                validate(context, null, formRoot, force); /// , forceRequired);

            });
        });

        context.validate = function(forceRequired) {
            return validate(context, null, formRoot, forceRequired);
        };

        moduleHelper.fields.radiobutton.bindValidationEvents(context, validate);

    }

    next(formRoot);

}

function checkForced(context, value) {

    // Check if the consent part is forced, meaning that one value has to be choosen
    // but only if the user has given email
    var parent = context.closest('div[data-formid]');
    var consentContext = parent.querySelector('[data-module="consent"]');
    var emailContext = parent.querySelector('[data-module="email"]');
    var isForced = false;
    if (consentContext) {
        isForced = consentContext.isForced();
        var emailValue = emailContext ? emailContext.get() : '';
        if (isForced && !value && emailValue) {
            return true;
        }
    }

    return false;

}


function get(context) {
    return radiobutton.get(context);
}

function reset(context) {
    radiobutton.reset(context);
}

module.exports = {
    parse: parse,
    validate: validate,
    init: init,
    get: get,
    reset: reset
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/consentemail/consentemail.js